import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import { routes } from 'config';
import { LoadingPage } from 'components/loading';
import { useBillingStatus } from 'hooks/use-billing-status.hook';
import { BillPayCta } from '../../components/bill-pay-cta';
import { BillingBase } from '../../billing-base';
import { Statement } from '../../secondary/statement';
import { Statements } from '../../secondary/statements';
import { EmptyState } from './empty-state';
import { DelayPayment } from '../../secondary/delay-payment';
import { PayBalance } from '../../secondary/pay-balance';

const BillingActive = () => {
  const { planId } = useParams<{ planId?: string }>();

  const { data, error, loading } = useBillingStatus({
    planId: Number(planId),
  });

  const [shouldShowEmptyState, setShouldShowEmptyState] = useState(false);

  const { issuedStatements, mostRecentStatement, balances, paymentLink } = data;

  useEffect(() => {
    setShouldShowEmptyState(false);
  }, [planId]);

  useEffect(() => {
    // If the data has loaded without error and the mostRecentStatement is still null,
    // this user doesn't have any statements yet and we should show
    // them the sunrise state
    if (!mostRecentStatement?.data && !error && !loading)
      setShouldShowEmptyState(true);
  }, [mostRecentStatement?.data, error, loading]);

  if (loading) return <LoadingPage />;

  return shouldShowEmptyState ? (
    <EmptyState />
  ) : (
    <BillingBase
      billPayCta={<BillPayCta />}
      error={error}
      issuedStatements={issuedStatements}
      loading={loading}
      mostRecentStatement={mostRecentStatement}
      balances={balances}
      paymentLink={paymentLink}
    />
  );
};

export const Active = () => {
  const routeTemplates = routes();

  return (
    <Switch>
      <Route
        path={routeTemplates.statementDelayPayment}
        component={DelayPayment}
      />
      <Route path={routeTemplates.statement} component={Statement} />
      <Route path={routeTemplates.statements} component={Statements} />
      <Route path={routeTemplates.payBalance} component={PayBalance} />
      <Route path={routeTemplates.billing} component={BillingActive} />
      <Redirect to={routeTemplates.billing} />
    </Switch>
  );
};
